import React, { useState, useEffect } from "react";
import CountyDropdown from "../components/CountyDropdown";
import CityDropdown from "../components/CityDropdown";
import ZipCodeDropdown from "../components/ZipCodeDropdown";
import BuildingTypeDropdown from "../components/BuildingTypeDropdown";
import GetPriceButton from "../components/GetPriceButton";
import ResultsDisplay from "../components/ResultsDisplay";
import UserLocation from "../components/UserLocation";
import MessageDisplay from "../components/MessageDisplay";
import BedBathSelector from "../components/BedBathSelector";
import BuildingTypeChart from "../components/BuildingTypeChart";
import MortgageCalculator from "../components/MortgageCalculator";
import RentalCalculator from "../components/RentalCalculator";
import GoogleAd from "../components/GoogleAd";
import logo from '../image/localreal_logo_trans_resize.png'; // Adjust the path as necessary

//const backendsourse = "http://127.0.0.1:8080"; // Update this to your backend URL if needed
//const backendsourse = "  https://d200-2600-1700-3bd2-8450-c508-53aa-eae0-2a7b.ngrok-free.app"; // Update this to your backend URL if needed
const backendsourse = "https://localreal-backend-91398629203.us-west2.run.app"; // Update this to your backend URL if needed
//const backendsourse = window.location.origin;
const MainPage = () => {
  const [data, setData] = useState({});
  const [counties, setCounties] = useState([]);
  const [selectedCounty, setSelectedCounty] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [zipCodes, setZipCodes] = useState([]);
  const [selectedZipCode, setSelectedZipCode] = useState("");
  const [buildingTypes] = useState(["Single Family House", "Town House", "Condo"]);
  const [selectedBuildingType, setSelectedBuildingType] = useState("");
  const [medianPrice, setMedianPrice] = useState(null);
  const [transactionCount, setTransactionCount] = useState(null);
  const [message, setMessage] = useState("");
  const [pricemessage, setPriceMessage] = useState("");
  const [detectingLocation, setDetectingLocation] = useState(false);
  const [bedrooms, setBedrooms] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [medianPricePerSqft, setMedianPricePerSqft] = useState(null);
  const [saleToListRatio, setSaleToListRatio] = useState(null);
  const [averageDOM, setAverageDOM] = useState(null);
  const [buildingTypeData, setBuildingTypeData] = useState([]);
  const [activeCalculator, setActiveCalculator] = useState("mortgage");
  

  useEffect(() => {
    fetch(backendsourse + "/api/location-data")
      .then((response) => response.json())
      .then((dataFromBack) => {
        setData(dataFromBack);
        setCounties(Object.keys(dataFromBack));
      })
      .catch((error) => console.error("Error fetching location data:", error));
  }, []);

  // useEffect(() => {
  //   detectUserLocation();
  // }, []);

  const handleCountyChange = (county) => {
    setSelectedCounty(county);
    setCities(Object.keys(data[county] || {}));
    setSelectedCity("");
    setZipCodes([]);
    setSelectedZipCode("");
    setMedianPrice(null);
    setTransactionCount(null);
  };

  const handleCityChange = (city) => {
    setSelectedCity(city);
    const countyData = data[selectedCounty];
    if (countyData && countyData[city]) {
      setZipCodes(countyData[city].sort());
    } else {
      console.warn("City not found in county data:", selectedCounty, city);
      setZipCodes([]);
    }
    setZipCodes((data[selectedCounty][city] || []).sort());
    setSelectedZipCode("");
    setMedianPrice(null);
    setTransactionCount(null);
  };

  const handleZipCodeChange = (zip) => {
    setSelectedZipCode(zip);
    setMedianPrice(null);
    setTransactionCount(null);
  };

  const handleBuildingTypeChange = (e) => {
    setSelectedBuildingType(e.target.value);
    setMedianPrice(null);
    setTransactionCount(null);
  };

  const getBuildingTypeDistribution = () => {
    fetch(backendsourse + "/api/building-type-distribution", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        county: selectedCounty,
        city: selectedCity || null,
        zip: selectedZipCode || null,
        bedrooms: bedrooms || null,
        bathrooms: bathrooms || null
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.distribution) {
          setBuildingTypeData(data.distribution);
        }
      })
      .catch((error) => console.error("Error fetching building type distribution:", error));
  };

  const getMedianPrice = () => {
    fetch(backendsourse + "/api/median-price", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        county: selectedCounty,
        city: selectedCity || null,
        zip: selectedZipCode || null,
        bedrooms: bedrooms || null,
        bathrooms: bathrooms || null,
        buildingType: selectedBuildingType,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message || data.transactionCount === 0) {
          setPriceMessage(data.message);
          setTransactionCount("");
          setMedianPrice("");
          setMedianPricePerSqft(null);
          setSaleToListRatio(null);
          setAverageDOM(null);
          setBuildingTypeData([]); 
          //getBuildingTypeDistribution();
        } else {
          setPriceMessage("");
          setTransactionCount(data.transactionCount);
          setMedianPrice(data.medianPrice);
          setMedianPricePerSqft(data.medianPricePerSqft);
          setSaleToListRatio(data.saleToListRatio);
          setAverageDOM(data.averageDOM);
          getBuildingTypeDistribution();
        }
      })
      .catch((error) => console.error("Error fetching median price:", error));
  };

  const detectUserLocation = () => {
    if (!navigator.geolocation) {
      setMessage("Your location is not accessible");
      return;
    }

    setDetectingLocation(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;

        fetch(backendsourse + "/api/detect-location", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            latitude: Number(latitude.toFixed(3)),
            longitude: Number(longitude.toFixed(3)),
          }),
        })
          .then((response) => response.json())
          .then((userLocationData) => {
            if (userLocationData.zip && userLocationData.county && userLocationData.city) {
              setSelectedCounty(userLocationData.county);
              setSelectedCity(userLocationData.city);
              setSelectedZipCode(userLocationData.zip);
              
              setMessage(`You Are At: ${userLocationData.county} County, ${userLocationData.city}, ${userLocationData.zip}`);
            } else {
              setMessage("Could not determine location.");
            }
          })
          .catch((error) => {
            console.error("Error fetching location details:", error);
            setMessage("Error determining location.");
          })
          .finally(() => setDetectingLocation(false));
      },
      (error) => {
        console.error("Geolocation error:", error);
        setMessage("Your location is not accessible");
        setDetectingLocation(false);
      }
    );
  };

  useEffect(() => {
    if (selectedCounty) {
      handleCountyChange(selectedCounty);
    }
  }, [selectedCounty]);

  useEffect(() => {
    if (selectedCity && data[selectedCounty]?.[selectedCity]) {
      handleCityChange(selectedCity);
    }
  }, [selectedCity, selectedCounty, data]);

  useEffect(() => {
    if (selectedZipCode) {
      handleZipCodeChange(selectedZipCode);
    }
  }, [selectedZipCode]);

  return (
    
    <div className="p-6 ">
      
      <img src={logo} alt="LocalReal" style={{height: '90px', width: 'auto',marginBottom: '20px',marginTop: '-10px'}} />
      {/* <h1 className="text-2xl font-bold mb-4">Local Real</h1> */}
      <h2 className="text-2xl font-bold mb-4">Know Your Local Home Prices</h2>
      
      <div className="mb-4 flex gap-3">
        <UserLocation detectUserLocation={detectUserLocation} detectingLocation={detectingLocation} />
        <a
            href="https://www.buymeacoffee.com/localreal"
            target="_blank"
            rel="noopener noreferrer"
            className="mb-4 w-[200px] px-4 py-2 bg-[#185a8b] text-white text-sm font-semibold rounded-md hover:bg-[#426E8F] transition duration-200 shadow-sm rounded items-center flex justify-center"
          >
            🙏 Coffee ☕
        </a>

      </div>
      {/* <UserLocation detectUserLocation={detectUserLocation} detectingLocation={detectingLocation} /> */}
      <MessageDisplay message={message} />
      <CountyDropdown counties={counties} selectedCounty={selectedCounty} onChange={(e) => handleCountyChange(e.target.value)} />
      <CityDropdown cities={cities} selectedCity={selectedCity} onChange={(e) => handleCityChange(e.target.value)} />
      <ZipCodeDropdown zipCodes={zipCodes} selectedZipCode={selectedZipCode} onChange={(e) => handleZipCodeChange(e.target.value)} />
      <BuildingTypeDropdown buildingTypes={buildingTypes} selectedBuildingType={selectedBuildingType} onChange={handleBuildingTypeChange} />
      <BedBathSelector bedrooms={bedrooms} setBedrooms={setBedrooms} bathrooms={bathrooms} setBathrooms={setBathrooms} />
      <GetPriceButton onClick={getMedianPrice} />
     
      <ResultsDisplay pricemessage={pricemessage} medianPrice={medianPrice} transactionCount={transactionCount} medianPricePerSqft={medianPricePerSqft} saleToListRatio={saleToListRatio} averageDOM={averageDOM} />
    
      {buildingTypeData.length > 0 && <BuildingTypeChart data={buildingTypeData} />}
      <GoogleAd slot="1234567890" /> {/* Replace with your AdSense slot ID */}
      <div className="mt-8">
        <div className="mb-4 ">
          <button className={`mr-2 px-4 py-2 rounded  hover:bg-blue-700  ${activeCalculator === "mortgage" ? "bg-blue-600 text-white" : "bg-gray-200"}`} onClick={() => setActiveCalculator("mortgage")}>Mortgage Calculator</button>
          <button className={`px-4 py-2 rounded hover:bg-blue-700  ${activeCalculator === "rental" ? "bg-blue-600 text-white" : "bg-gray-200"}`} onClick={() => setActiveCalculator("rental")}>Rental Calculator</button>
        </div>
        
        {activeCalculator === "mortgage" && <MortgageCalculator />}
        {activeCalculator === "rental" && <RentalCalculator />}
      </div>
    </div>
  );
};

export default MainPage;




